const authKeys = {
    userInfo: ['userInfo'] as const,
    userInfoById: (id: string) => [...authKeys.userInfo, id] as const,
}

export default authKeys